export const THIS_PRODUCT_NAME_STRING = 'Jira';

export const APPLINKS_V3_QUERY_URL =
	'/rest/applinks/3.0/applinks?data=applicationVersion&data=atlassian&data=configUrl&data=iconUri&data=editable&data=v3Editable&data=webItems';
export const APPLINKS_V3_QUERY_SINGULAR_URL = (id: string) =>
	`/rest/applinks/3.0/applinks/${id}?data=applicationVersion&data=atlassian&data=configUrl&data=iconUri&data=editable&data=v3Editable&data=webItems`;
export const APPLINKS_V3_CLOUD_CONNECTOR_QUERY_SINGULAR_URL = (id: string) =>
	`${APPLINKS_V3_QUERY_SINGULAR_URL(id)}&property=CLOUD_CONNECTOR_PRODUCT_CONNECTION_ID`;
export const APPLINKS_LIST_PAGE_URL_LEGACY = '/plugins/servlet/applinks/listApplicationLinks';
export const APPLINKS_LIST_PAGE_URL = '/jira/settings/applinks';
export const APPLINKS_EDIT_PAGE_URL_FOR_ID = (id: string) => `/jira/settings/applinks/${id}/edit`;

export const APPLINKS_IS_OAUTH2_SUPPORTED_PROVIDER_CHECK =
	'com.atlassian.applinks.api.auth.types.ThreeLeggedOAuth2AuthenticationProvider';
